import { inject, Injectable, DOCUMENT } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from './user.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class LangsService {
  translate = inject(TranslateService)
  document = inject(DOCUMENT)
  userService = inject(UserService)
  apiService = inject(ApiService)
  public languages = [
    { code: 'ar', name: 'العربية' },
    { code: 'en', name: 'English' },
  ];
  public langs: string[] = this.languages.map(lang => lang.code);
  langSignal = toSignal(this.translate.onLangChange, {
    initialValue: { lang: this.translate.currentLang, translations: {} }
  });
  constructor() {
    let browserLang: string;
    this.translate.addLangs(this.langs);

    if (localStorage.getItem('lang')) {
      browserLang = localStorage.getItem('lang') as string;
    } else {
      browserLang = this.translate.getBrowserLang() as string;
      console.log({ browserLang })
    }
    this.translate.use(this.langs.includes(browserLang) ? browserLang : 'ar');

    this.translate.onLangChange.subscribe(event => {
      event.lang == 'ar' ? this.setRTLSettings() : this.setLTRSettings()
    })
  }

  changeUserLanguage(locale: string) {
    this.apiService.updateUserProfile({locale}).subscribe({
      next: () => {
        this.setLanguage(locale);
      }
    });
  }

  public setLanguage(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
    // window.location.reload();
  }

  setRTLSettings() {
    this.document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
    this.document.body.classList.add('rtl');
  }
  setLTRSettings() {
    this.document.getElementsByTagName('html')[0].removeAttribute('dir');
    this.document.body.classList.remove('rtl');
  }
}
